/* eslint-disable no-param-reassign */
import { action, thunk } from 'easy-peasy';
import { get, set } from 'lodash/fp';
import {
  fetchInventoryItemAvailability,
  fetchInventoryPackageAvailability
} from '../../../services/fbm-api';
import getItemAvailabilityUniqKey from '../../../helpers/inventory/getItemAvailabilityUniqKey';

export default {
  data: null,
  error: null,
  loading: false,
  fetch: thunk(async (actions, payload) => {
    try {
      actions.setError(null);
      actions.setLoading(true);
      const response = await (get('zoneId', payload)
        ? fetchInventoryItemAvailability(payload)
        : fetchInventoryPackageAvailability(payload));
      actions.set(response);
    } catch (error) {
      actions.setError(error);
    } finally {
      actions.setLoading(false);
    }
  }),
  set: action((state, response) => {
    const itemUniqKey = getItemAvailabilityUniqKey(response);
    state.data = set(itemUniqKey, response, state.data);
  }),
  clear: action(state => {
    state.data = null;
  }),
  clearError: action(state => {
    state.error = null;
  }),
  setError: action((state, error) => {
    state.error = error;
  }),
  setLoading: action((state, loading) => {
    state.loading = loading;
  })
};
